"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors;
    return ({
        stroke: function (customColors) { return ({
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            height: 4,
            backgroundImage: "linear-gradient(90deg, \n    ".concat(customColors ? customColors[0] : colors.Faceman.default, " 25%, \n    ").concat(customColors ? customColors[1] : colors.Hannibal[500], " 62%,\n    ").concat(customColors ? customColors[2] : colors.Baracus.default, " 80%)"),
        }); },
    });
});
var GradientStroke = function (_a) {
    var colors = _a.colors;
    var styles = useStyles(colors);
    return react_1.default.createElement("div", { className: styles.stroke });
};
exports.default = GradientStroke;
//# sourceMappingURL=index.js.map